import * as React from "react";
import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import "./EnrollmentModal.css";
import { Grid } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { getenrollmentresident } from "../common/constants/globalconstants";
import { useAuth0 } from "@auth0/auth0-react";
import { maskedAccountId } from "../common/Utils";
import ErrorModal from "../common/ErrorModal";
import axiosInstance from "../common/AxiosInterceptor";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "80%",
  overflowY: "auto",
  borderRadius: "10px",
};

const msgModalStyle = {
  borderRadius: "10px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "40%",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",
};

const benefitTypeList = JSON.parse(localStorage.getItem("benefitTypeList"));
var descriptionarray = [];

export default function EnrollmentModal(props) {
  const { user } = useAuth0();
  //const storetoken = useSelector((state) => state.storetoken);
  const [open, setOpen] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [errormodalopen, seterrormodalOpen]= useState(false);
  
  let navigate = useNavigate();
  const majorarray = [...props.benefitTypeList]; //from server
  const miniarray = [...props.enrollmentFields.benefitTypes]; //from enrolment form

  const [descriptionarray, setdescriptionarray] = React.useState([
    ...props.enrollmentFields.benefitTypes,
  ]);

 
  useEffect(() => {
    setUserDetails(user);
  }, [user?.sub]);

  React.useEffect(() => {
    var updateddescriptionarray = [];
    //nested map
    miniarray.map((ele) => {
      majorarray.map((e) => {
        if (ele === e.btInitials)
          updateddescriptionarray = [
            ...updateddescriptionarray,
            e.btDescriptions,
          ];
      });
    });

    setdescriptionarray(updateddescriptionarray);
  }, []);
  /*const handleClick = () => {
    setOpen(true);
    setTimeout(() => {
      props.plzclose();
      //navigate('/PasswordChanged');
    }, 2000);
  };*/

  const handlesnackbarClick = () => {
    submitEnrollmentData();
    //0th sec indicator starts

    /* setTimeout(()=>{
      props.requestsnackbardata(true);
      props.plzclose(); //modal closes after 4 sec
      
      //navigate('/PasswordChanged');
    }
    ,4000);
    setTimeout(()=>{
      
      //some time for alert toaster
      navigate('/DirectDepositListing');
    }
    ,11000); */
  };
  //"https://vm-colbweb2d/fastlink/api/private/enrollResident"

  const submitEnrollmentData = async () => {
    try {
      //const accToken = await getAccessTokenSilently();
      const enrollmentData = getEnrollmentData(props.enrollmentFields);
      const response = await axiosInstance.post(`${getenrollmentresident}`, JSON.stringify(enrollmentData));
      if (response.data.isSuccess) {
        props.requestsnackbardata(true);
        props.plzclose();
        //navigate("/DirectDepositListing");
        seterrormodalOpen(false);
        props.setSuccess(true);
        props.setModalOpen(true);
      }else if (!response.data.isSuccess) {
        seterrormodalOpen(true);
        props.setSuccess(false);
      }
    } catch (error) {
      console.log(error);
      seterrormodalOpen(true);
    }
  };

  const getEnrollmentData = (data) => {
   
    return {
      enrollmentId: data.enrollmentId, //it cant be 0 for edit enrollment , 0 for new enrolment
      userName: userDetails.email,
      enrollmentDate: data.enroll_date,
      payeeLastName: data.lastName,
      payeeFirstName: data.firstName,
      ssn: data.SSN,
      representativePayee: data.repre_payee,
      medicaId: data.medi,
      residentId: data.resiID,
      //allowance: data.allowance && !Number.isInteger(data.allowance)? (parseFloat(data.allowance)).toFixed(2).toString(): allowance,
      allowance: data.allowance && data.allowance.includes(".")? ((data.allowance).replace(/^0+(?!\.)/, "") || "0"): 
      data.allowance && !data.allowance.includes(".") ? ((data.allowance+".00").replace(/^0+(?!\.)/, "") || "0"): "",
      benefitTypes: data.benefitTypes, //passing only initials to direct deposit listing page POST req
    };
  };

  /*const handleClose = () => {
    setOpen(false);
  };*/
  const [contentsopen, setcontentsOpen] = React.useState("***********");
  const contentopen = () => {
    setcontentsOpen(props.enrollmentFields.SSN);
  };
  const contentclose = () => {
    setcontentsOpen("***********");
  };
  const [accountsopen, setaccountsOpen] = React.useState(
    maskedAccountId(props.enrollmentFields.accountNum)
  );
  const accountopen = () => {
    setaccountsOpen(props.enrollmentFields.accountNum);
  };
  const accountclose = () => {
    setaccountsOpen(maskedAccountId(props.enrollmentFields.accountNum));
  };
  return (
    <div>
      <Modal
        open={props.open}
        onClose={props.plzclose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="modalstyle"
      >
        {props.duplicateSsn ? 
        <Box sx={msgModalStyle}>
          <Typography id="shadow" style={{fontSize:"20px", fontWeight:"150px"}}>
            {" "}
            {props.duplicateMsg}
          </Typography>
          <Button
            style={{
              width:"100px", 
              height:"35px",
              backgroundColor: "#002d82",
              textTransform: "unset !important",
              paddingRight: "10px",
              marginLeft: "20px",
              marginTop:"5px",
              marginBottom:"5px"}}
            variant="contained"
            onClick={props.plzclose}
          >
            Close
          </Button>
        </Box> : 
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h5" component="h2">
            Enrollment Verification
            <IconButton
              aria-label="close"
              onClick={props.plzclose}
              sx={{
                position: "absolute",
                right: 35,
                top: 20,
                color: "white",
                backgroundColor: "red",
                padding: "2px",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Typography>
          <hr></hr>
          <Box id="details">
            <Grid className="modalcolumn">
              <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box id="payeename">
                    <strong> Payee name </strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {`${props.enrollmentFields.firstName} ${props.enrollmentFields.lastName}`}{" "}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
              <Grid item xs={6}>
                {" "}
                {/* <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box id="payeename">
                    {" "}
                    <strong>A/C Type</strong> <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      {props.enrollmentFields.acc_type}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "} */}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>Residence ID </strong>{" "}
                    <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      {props.enrollmentFields.resiID}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
            <Grid className="modalcolumn">
              <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong>SSN</strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      <Tooltip
                        id="tooltip"
                        onOpen={contentopen}
                        onClose={contentclose}
                        title="  "
                        placement="left-start"
                      >
                        <IconButton id="iconbutton">{contentsopen}</IconButton>
                      </Tooltip>
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
              <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>A/C No.</strong> <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      <Tooltip
                        id="tooltip"
                        onOpen={accountopen}
                        onClose={accountclose}
                        title="  "
                        placement="right-start"
                      >
                        <IconButton id="iconbutton">{accountsopen}</IconButton>
                      </Tooltip>
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
            <Grid className="modalcolumn">
              <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong> Representative Payee </strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {props.enrollmentFields.repre_payee}{" "}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
              <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>Enrollment Date</strong>{" "}
                    <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      {props.enrollmentFields.enroll_date}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
            <Grid className="modalcolumn">
              <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong>Telephone No</strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {props.enrollmentFields.tele_number}{" "}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
              <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>Contact</strong> <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      {props.enrollmentFields.contact}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
            <Grid className="modalcolumn">
              <Grid item xs={12}>
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong> Address-Street </strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {props.enrollmentFields.address.street}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
            <Grid className="modalcolumn">
              <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong> City </strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {props.enrollmentFields.address.city}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
              <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    <strong> State </strong>
                    <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      {" "}
                      {props.enrollmentFields.address.state}{" "}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
            <Grid className="modalcolumn">
              <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>Zip Code</strong> <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {props.enrollmentFields.address.zip_code}{" "}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>

              <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>Medicaid</strong> <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      {props.enrollmentFields.medi}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
            </Grid>
            <Grid className="modalcolumn" id="lastgrid">
              <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-left" sx={{ mt: 2 }}>
                  <Box>
                    <strong> Allowance </strong>
                    <span id="mspan-left">:</span>
                    <span id="modalspan-left">
                      {" "}
                      {props.enrollmentFields.allowance && props.enrollmentFields.allowance.includes(".")?  <><strong>$</strong> {(props.enrollmentFields.allowance).replace(/^0+(?!\.)/, "") || "0"}</>:
                      props.enrollmentFields.allowance && !props.enrollmentFields.allowance.includes(".")? <><strong>$</strong>{(props.enrollmentFields.allowance+".00").replace(/^0+(?!\.)/, "") || "0"}</>
                      :""}{" "}
                      {" "}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid>
              {/* <Grid item xs={6}>
                {" "}
                <Typography id="modal-description-right" sx={{ mt: 2 }}>
                  <Box>
                    {" "}
                    <strong>Residence ID </strong>{" "}
                    <span id="mspan-right">:</span>
                    <span id="modalspan-right">
                      {props.enrollmentFields.resiID}
                    </span>{" "}
                  </Box>{" "}
                </Typography>{" "}
              </Grid> */}
            </Grid>
            <hr></hr>
          </Box>

          <Box id="modalbenefits" sx={{ color: "#002d82" }}>
            <strong>
              <span id="types">Types of Benefits</span>
            </strong>
            <br></br>
            <Box id="mytob">
              {descriptionarray.map((type, idx) => {
                //to get only initials use this below
                //props.enrollmentFields.benefitTypes
                return (
                  <Box key={idx} className="tob">
                    {type}&nbsp; &nbsp;
                  </Box>
                );
              })}
            </Box>
          </Box>

          <hr></hr>
          <br></br>
          <Box>
            <strong>
              <span id="submit">Do you want to submit this information?</span>
            </strong>
            <Button
              id="btn1"
              variant="contained"
              href="#DirectDepositListing"
              onClick={handlesnackbarClick}
              type="submit"
            >
              Yes
            </Button>

            <Button
              color="error"
              id="btn2"
              variant="outlined"
              onClick={props.plzclose}
            >
              No
            </Button>
          </Box>
          {open && (
            <>
              <CircularProgress color="success" pointerEvents={"none"} />
              <span>Submitting data</span>
            </>
          )}
        </Box>}

      </Modal>
      {errormodalopen && (
        <ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
      )}
    </div>
  );
}
